import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';

export default function CaseStudies() {
  const [studies, setStudies] = useState([]);
  useEffect(() => {
    api.get('/case-studies').then((r) => setStudies(r.data)).catch(() => {});
  }, []);

  if (!studies.length) return null;

  return (
    <section id="work" className="relative py-28 md:py-40 bg-paper" data-testid="case-studies-section">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <div className="flex items-baseline justify-between mb-14">
          <div className="mono text-xs uppercase tracking-[0.3em] text-orchid">(05) — Case studies</div>
          <div className="mono text-[10px] uppercase tracking-[0.3em] text-ink/40 hidden md:block">The system that built itself</div>
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="serif text-[12vw] md:text-[8vw] leading-[0.9] text-ink mb-16 md:mb-24"
        >
          Selected <span className="italic text-grape">work</span>.
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-ink/10 border border-ink/10">
          {studies.map((s, i) => (
            <motion.div
              key={s.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.7, delay: i * 0.06 }}
              className="group bg-paper"
              data-testid={`case-card-${s.slug}`}
            >
              <Link to={`/work/${s.slug}`} className="block p-8 md:p-12 h-full relative overflow-hidden">
                <div className="flex items-baseline justify-between mb-8">
                  <div className="mono text-[10px] uppercase tracking-[0.3em] text-orchid">Case · {s.number}</div>
                  <div className="mono text-[10px] uppercase tracking-[0.3em] text-ink/40">{(s.stack || []).join(' / ')}</div>
                </div>
                <h3 className="serif text-4xl md:text-6xl text-ink leading-[0.95] mb-4 group-hover:text-grape transition-colors">
                  {s.title}
                </h3>
                <p className="mono text-sm text-ink/60 italic mb-6">{s.tag}</p>
                <p className="mono text-[14px] md:text-[15px] text-ink/80 leading-relaxed max-w-xl">{s.blurb}</p>
                <div className="mt-10 inline-flex items-center gap-2 mono text-[11px] uppercase tracking-[0.3em] text-ink group-hover:text-orchid transition-colors">
                  Open case
                  <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
                </div>
                <div className="absolute right-8 top-8 serif text-[10rem] md:text-[14rem] text-lilac/25 leading-none pointer-events-none select-none">
                  {s.number}
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
